import { Stack, Typography, Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'

function List2({ operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  // function ListTop ( { fetchOperations, operations, setSelectedRows } )
  const siteUser = useSelector((store) => store.user)

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'EquipementType',
      headerName: 'Date',
      width: 310,
      flex: 1,
      editable: true,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" paddingBottom="10px">
            <Box>
              <Typography sx={{ fontSize: '22px', fontWeight: '600' }}>
                {' '}
                {params.row.Name}
              </Typography>
              <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>
                {' '}
                {params.row.entreprise?.Name}
              </Typography>

              <Typography sx={{ fontSize: '14px', color: '#898989' }}>
                {convertToUserDateFormate(siteUser.user, params.row.BeginDate)} -{' '}
                {convertToUserDateFormate(siteUser.user, params.row.endDate)}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
  ]

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('parcoursPro.titleFormation') /* LAP-733 (GE022) */} ({operations.count})
      </Typography>

      <DataGrid
        getRowHeight={() => 'auto'}
        // getEstimatedRowHeight={() => 200}
        sx={{
          height: 700,
          '.MuiDataGrid-footerContainer': { display: 'none' },
          '& .MuiDataGrid-columnHeaders': { display: 'none' },
          '& .MuiDataGrid-virtualScroller': { marginTop: '10px !important' },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(e) => navigate(`/parcourspro/formation/${e.row.id}`)}
      />
    </div>
  )
}
export default List2
